import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Company } from "../../model/shared.model";

@Injectable({
    providedIn: 'root'
  })
export class PlantOwnershipService {
    baseurl = environment.apiBaseUrl;

    constructor(protected http: HttpClient) {
    }

    getCompanies(companyName: string, siteType: string, multiNationalCompanies: boolean) {
        return this.http.get<Company[]>(this.baseurl + `company/getcompanies?companyName=${companyName}&siteType=${siteType}&multiNationalCompanies=${multiNationalCompanies}`);
    }

    saveCustomerSiteInfo(companySiteVM: any, siteId: number) {
        return this.http.post<any[]>(this.baseurl + `companysite/savecompanysitedata/${siteId}`, companySiteVM)
    }

    saveCompany(companyVM: Company) : Observable<number> {
        return this.http.post<number>(this.baseurl + `company/addcompany`, companyVM)
    }
}